import MuiListItemButton, { ListItemButtonProps } from '@mui/material/ListItemButton';
import { styled } from '@mui/material/styles';


interface StyledListItemButton extends ListItemButtonProps {
  single?: boolean;
  nested?: boolean;
  isRTL?: boolean;
}

const ListItemButton = styled(MuiListItemButton, {
  shouldForwardProp: (prop) => prop !== 'single' && prop !== 'nested' && prop !== 'isRTL'
})<StyledListItemButton>(({ single, nested, isRTL, theme }) => {
  const textStyle = {
    typography: {
      '& .MuiTypography-root': {
        paddingLeft: isRTL ? 0 : theme.spacing(1.5),
        paddingRight: isRTL ? theme.spacing(1.5) : 0,
        textAlign: isRTL ? 'right' : 'left',
        fontFamily: `'Somar Sans', sans-serif`,
        fontSize: '1.4rem',
        lineHeight: '19px',
        color: theme.palette.grey[400],
        fontWeight: 400
      }
    },
    activeTypography: {
      '& .MuiTypography-root': {
        fontWeight: 600,
        color: theme.palette.primary.main
      }
    }
  };

  return {
    borderRadius: theme.spacing(1),
    '& .MuiListItemText-root': {
      margin: 0,
      ...textStyle.typography,
      textAlign: isRTL ? 'right' : 'left'
    },
    '& .MuiListItemIcon-root': {
      minWidth: theme.spacing(3)
    },
    '& .MuiListItemText-primary': {
      textAlign: isRTL ? 'right' : 'left',
      direction: isRTL ? 'rtl' : 'ltr'
    },
    '&:hover': {
      backgroundColor: single ? theme.palette.common.white : theme.palette.action.hover,
      ...textStyle.activeTypography
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.action.active,
      ...textStyle.activeTypography,
      '&:Hover': {
        backgroundColor: theme.palette.action.hover
      }
    },
    ...(single && {
      marginBottom: theme.spacing(1)
    }),
    ...(nested && {
      padding: isRTL ? '0.4rem 5.2rem 0.4rem 0.9rem' : '0.4rem 0.9rem 0.4rem 5.2rem',
      '& .MuiListItemText-root': {
        '& .MuiTypography-root': {
          ...textStyle.typography['& .MuiTypography-root'],
          paddingLeft: isRTL ? 0 : 0,
          paddingRight: isRTL ? 0 : 0
        }
      }
    })
  };
});

export default ListItemButton;
